import { reactive, ref } from 'vue'

// 全局状态
const globalLoading = ref(false)

// 默认配置
const defaultConfig = {
  text: '加载中...',
  fullscreen: false
}

const globalLoadingConfig = reactive({
  text: defaultConfig.text,
  fullscreen: defaultConfig.fullscreen
})

/**
 * 设置全局loading
 *  text: loading 文本
 *  fullscreen: 是否全屏 默认不全屏
 * @param fullscreen
 * @param text
 */
function openGlobalLoading(fullscreen: boolean, text?: string) {
  globalLoading.value = true
  
  // 重置为默认配置，然后合并新配置
  globalLoadingConfig.text = text ?? defaultConfig.text
  globalLoadingConfig.fullscreen = fullscreen ?? defaultConfig.fullscreen
}

/**
 * 关闭全局loading
 */
function closeGlobalLoading() {
  globalLoading.value = false
}

/**
 * 使用全局loading hook
 */
export function useGlobalLoading() {
  return {
    globalLoading,
    globalLoadingConfig,
    openGlobalLoading,
    closeGlobalLoading
  }
}
